// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29n1O","tabsBox":"styles_tabsBox__2LOu5","createButton":"styles_createButton__3kit1"};